import {
  omitSpacePresentation,
  type SpaceDescriptor,
} from "@mind-sands/shared";

/** Pretty-print a SpaceDescriptor for git-friendly seed files. */
export function formatSpaceJson(space: SpaceDescriptor): string {
  return JSON.stringify(omitSpacePresentation(space), null, 2) + "\n";
}

/** Trigger a browser download of `{slug}.json` for committing back to spaces/json/. */
export function downloadSpaceJson(space: SpaceDescriptor): void {
  const slug = space.slug || space.id;
  const blob = new Blob([formatSpaceJson(space)], {
    type: "application/json",
  });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = `${slug}.json`;
  anchor.click();
  URL.revokeObjectURL(url);
}
